import React from "react";
import { useParams } from "react-router-dom";

function GamePlayer() {
  const { gameId } = useParams();

  return (
    <div>
      <h2>Playing Game: {gameId}</h2>
      <iframe
        title="game"
        src={`https://your-public-r2-url.com/games/${gameId}/index.html`}
        style={{ width: "100%", height: "80vh", border: "none" }}
        allowFullScreen
      />
    </div>
  );
}

export default GamePlayer;